import React, { Component } from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonButton,
  IonBackButton,
  isPlatform,
} from "@ionic/react";
import { RouteComponentProps, withRouter } from "react-router";

// CSS
import "./ContactPage.css";
import "../../Shared.css";
import "../../../App.css";

// Images
import iconClose from "../../assets/Button_Close@3x.png";

// Controllers
import { IScreenProps, IUser } from "../../Interfaces";
import { Preferences } from "@capacitor/preferences";
import DataController from "../../controllers/DataController";

// Components

type Props = RouteComponentProps<{ id: string; tab: string }> & { screenProps: IScreenProps; features: string[] };
type State = {
  showOlark: boolean;
};

class ContactPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { showOlark: false };
  }

  async componentDidMount() {
    let showOlarkData = await DataController.getShouldShowOlark();
    this.setState({ showOlark: showOlarkData });
  }

  supportEmail(event: any) {
    this.props.screenProps.sendSupportEmail("Subscription Support");
  }

  render() {
    let html = (
      <div>
        {this.state.showOlark === true && (
          <>
            <h1>Start a text chat</h1>
            <p>
              Start a chat with us, our customer support team are ready to answer any questions you have from 9am to
              5am.
              <br />
              <IonButton
                mode="ios"
                className="filledButton contactUsChatButton"
                strong={true}
                onClick={() => {
                  this.props.screenProps.showOlark(true);
                }}
              >
                Start Chat
              </IonButton>
            </p>
          </>
        )}
        <h1>Login & subscription help</h1>
        <p>
          For specific troubleshooting help regarding subscriptions, accounts and signing up/login, please send us{" "}
          <a
            onClick={this.props.screenProps.sendSupportEmail.bind(this, "Subscription Support")}
            href="javascript:void(0);"
          >
            this formatted email
          </a>{" "}
          with a description of the issue.{" "}
        </p>
        <h1>Email or call </h1>
        <p>
          Let us know if you have an issue, suggestion or any feedback. We're always trying to improve the app. Email us
          at <a href="mailto:apps@class.co.uk">apps@class.co.uk</a> or call us on 01278 427 800
        </p>
      </div>
    );

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonButtons slot="start" className="headerButtonText" color="#FFFFFF">
              <IonBackButton defaultHref={`/${this.props.match.params.tab}`} class="headerButtonText" />
            </IonButtons>
            <IonTitle>Contact us</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen className="modalContent">
          <div className="conactUsContent globalContentMargin">{html}</div>
        </IonContent>
      </IonPage>
    );
  }
}

export default withRouter(ContactPage);
